module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-57x57-c3e8da1a5ef1a46ce4f161eb2a3ff276.png";